var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-flex-row tw-items-center"},[_c('div',{staticClass:"tw-flex tw-flex-row tw-w-full tw-items-center tw-space-x-4"},[_c('div',{staticClass:"tw-flex-none"},[_vm._t("left")],2),_c('div',{staticClass:"tw-flex-1 tw-px-3"},[_vm._t("right")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }